import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import type { ReactNode } from "react";
import { locumLayout } from "@/theme";

export default function Container({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={{
        maxWidth: locumLayout.maxWidth,
        mx: "auto",
        px: { xs: "1.25rem", sm: locumLayout.containerPadding },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
